import { MOP_TYPES } from "../contants";

// in m2/hr
export const CLEANING_RATES = {
  [MOP_TYPES.STRING_MOP]: 400,
  [MOP_TYPES.MICRO_FIBRE_FLAT_MOP]: 720,
  [MOP_TYPES.IMOPLITE]: 1200,
  [MOP_TYPES.IMOPXL]: 1630,
  [MOP_TYPES.IMOPXXL]: 2200,
};

// in L/100m2
export const WATER_USAGES = {
  [MOP_TYPES.STRING_MOP]: 5.8,
  [MOP_TYPES.MICRO_FIBRE_FLAT_MOP]: 1.8,
  [MOP_TYPES.IMOPLITE]: 0.7333,
  [MOP_TYPES.IMOPXL]: 0.5666,
  [MOP_TYPES.IMOPXXL]: 0.3333,
};
